import { Component, Input } from '@angular/core';
import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { RxModel } from '@shared/models/rx-models/interfaces/rx-model';
import { TreatmentInformationComponentPart } from './models/treatment-information-component.enum';

@Component({
	selector: 'rx-treatment-information',
	template: `
		<ng-container [ngSwitch]="treatmentType">
			<rx-treatment-information-v0
				*ngSwitchCase="'caseType'"
				[isTreatmentsTableShownEmpty]="isTreatmentsTableShownEmpty"
				[rxForPrint]="rxForPrint"
			>
			</rx-treatment-information-v0>
			<rx-treatment-information-v1
				*ngSwitchCase="'procedureFlow'"
				[isTreatmentsTableShownEmpty]="isTreatmentsTableShownEmpty"
				[rxForPrint]="rxForPrint"
			>
			</rx-treatment-information-v1>
			<rx-treatment-information-art *ngSwitchCase="'art'" [rxForPrint]="rxForPrint"></rx-treatment-information-art>
		</ng-container>
	`
})
export class TreatmentInformationComponent extends BaseDestroyableComponent {
	@Input() rxForPrint: { rx: RxModel; componentPart?: TreatmentInformationComponentPart };
	@Input() isTreatmentsTableShownEmpty = true;
	@Input() isProcedureFlow: boolean;

	get treatmentType(): 'caseType' | 'procedureFlow' | 'art' {
		if(this.rxForPrint?.rx?.Order?.ProcedureId === ProcedureEnum.InvisalignART) {
			return 'art';
		}
		if(this.isProcedureFlow) {
			return 'procedureFlow';
		}
		return 'caseType';
	}

	constructor() {
		super();
	}
}
